import { EmailAttachment, EmailAttachmentJson } from '@models/email-attachment';

export interface SmsTemplateJson {
  body: string;
  to: string[];
  attachments: Partial<EmailAttachmentJson>[];
}

export class SmsTemplate {
  constructor(
    public body: string,
    public to: string[] = [],
    public attachments: EmailAttachment[] = []
  ) {}

  static fromJson(json: Partial<SmsTemplateJson>): SmsTemplate {
    return new SmsTemplate(
      json.body,
      json.to ?? [],
      (json.attachments ?? []).map((json: EmailAttachmentJson) => EmailAttachment.fromJson(json))
    );
  }

  static toJson(sms: SmsTemplate): Partial<SmsTemplateJson> {
    return {
      body: sms.body,
      to: sms.to,
      attachments: (sms.attachments ?? []).map((attachment: EmailAttachment) => EmailAttachment.toJson(attachment))
    };
  }
}
